import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import download from "downloadjs";
import head from "lodash/head";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { Button, ButtonGroup, ButtonToolbar } from "react-bootstrap";
import { Chart } from "react-google-charts";
import { FormattedMessage } from "react-intl";

export class IndicatorChart extends Component {
  constructor(props) {
    super(props);
    this.downloadChart = this.downloadChart.bind(this);
    this.handleChartData = this.handleChartData.bind(this);
    this.handleChartOptions = this.handleChartOptions.bind(this);
    this.state = {
      indicator: null,
      visualization: props.indicator ? head(props.indicator.visualizations) : null,
      name: props.indicator ? props.indicator.name : null,
      description: props.indicator ? props.indicator.description : null,
      chartImageURI: null
    };
  }

  handleChartOptions(visualization, name) {
    let statistic = visualization.statistic;
    if (statistic instanceof Array) {
      let total1 = -1;
      let total2 = -1;
      let total3 = -1;
      statistic.forEach(function (row) {
        let isHeader = row.indexOf("TOTAL") > -1;
        if (isHeader) {
          total1 = row.indexOf("N");
          total2 = row.indexOf("n");
          total3 = row.indexOf("TOTAL");
        } else {
          if (name) {
            let title = name;

            title = title.replace("TOTAL1", row[total1].toString());
            title = title.replace("TOTAL2", row[total2].toString());
            title = title.replace("TOTAL3", row[total3].toString());
            name = title;
          } else {
            let title = visualization.options.title;

            title = title.replace("TOTAL1", row[total1].toString());
            title = title.replace("TOTAL2", row[total2].toString());
            title = title.replace("TOTAL3", row[total3].toString());
            visualization.options.title = title;
          }
        }
      });
    }
    if (name) {
      return name;
    } else {
      return visualization.options;
    }
  }

  handleChartData(data) {
    let dataCopy = [];
    if (data instanceof Array) {
      data.forEach(function (row) {
        let indexOfAnnotation = row.indexOf("ANNOTATION");
        let isTotal = row.indexOf("TOTAL") > -1;
        if (!isTotal && indexOfAnnotation > -1) {
          let valueCopy = [];
          row.forEach(function (value) {
            if (value.toString().includes("ANNOTATION")) {
              valueCopy.push({ role: "annotation" });
            } else {
              valueCopy.push(value);
            }
          });
          dataCopy.push(valueCopy);
        } else if (!isTotal) {
          dataCopy.push(row);
        }
      });
    }

    return dataCopy;
  }

  render() {
    const { description, visualization, name, chartImageURI } = this.state;

    return (
      <>
        <div className="bg-light p-2 mt-4">
          {name && <h5>{this.handleChartOptions(visualization, name)}</h5>}
          {visualization.data && visualization.data.length > 1 ? (
            <Chart
              className="chart border"
              chartType={visualization.chartType}
              width={visualization.width}
              height={visualization.height}
              rows={visualization.rows}
              columns={visualization.columns}
              data={this.handleChartData(visualization.data)}
              options={this.handleChartOptions(visualization)}
              legendToggle={false}
              chartEvents={visualization.chartEvents}
              chartPackages={["corechart", "controls", "table", "timeline", "treemap", "wordtree", "gantt"]}
              chartLanguage="de"
              getChartWrapper={(chartWrapper, google) => {
                google.visualization.events.addOneTimeListener(chartWrapper, 'ready', (function() {
                  const chartImageURI =
                    chartWrapper.getChart() && typeof chartWrapper.getChart().getImageURI === "function"
                      ? chartWrapper.getChart().getImageURI()
                      : null;
                  this.setState({ chartImageURI });
                }).bind(this));
                chartWrapper.draw();
              }}
            />
          ) : (
            <div>
              <h6>{description}</h6>
              <small>
                <FormattedMessage id="collapsible.table.nodata" />
              </small>
            </div>
          )}
        </div>
        {chartImageURI && (
          <ButtonToolbar className="bg-light rounded-0 w-100 border-top">
            <ButtonGroup>
              <Button variant="light" onClick={() => this.downloadChart(chartImageURI)}>
                <FormattedMessage id="app.common.action.download" />
                <FontAwesomeIcon icon={faDownload} className="ms-2" />
              </Button>
            </ButtonGroup>
          </ButtonToolbar>
        )}
      </>
    );
  }

  downloadChart(chartImageURI) {
    download(chartImageURI, "chart.png", "image/png");
  }
}

IndicatorChart.propTypes = {
  chartData: PropTypes.object,
  description: PropTypes.string,
  name: PropTypes.string
};

export default IndicatorChart;
